import {
  ISortParams,
  SortOrderParam,
} from "../../../interfaces/queryFilters.interface";
import { BusinessSortField, isBusinessSortField } from "./businessSortField";

// Maps the antd table sort state to the getAll sortBy/sortOrder query params,
// dropping any field the backend no longer advertises as sortable so a stale
// selection never sends an unsupported sortBy.
export function resolveBusinessSortParam(
  sortField: string | undefined,
  sortOrder: string | undefined,
  sortableFields: BusinessSortField[]
): ISortParams {
  if (
    !sortField ||
    !isBusinessSortField(sortField) ||
    !sortableFields.includes(sortField)
  ) {
    return {};
  }
  const order: SortOrderParam | undefined =
    sortOrder === "ascend"
      ? "asc"
      : sortOrder === "descend"
        ? "desc"
        : undefined;
  if (!order) return {};
  return { sortBy: sortField, sortOrder: order };
}
